export type MessageStatus = 'success' | 'error'

export const variantStyles: Record<MessageStatus, string> = {
  success: '#161e2d',
  error: '#A30000'
}